import styled from "@emotion/styled/macro";
import headerMobile from "../../assets/images/abroadheaderMobile.png";
import header from "../../assets/images/abroadheader.png";
import { BodyContentLayout } from "../../components/ui/ContentLayout";
import { useTranslation } from "react-i18next";
import FaqPart from "../Faq/FaqPart";
import PageHeader from "../../components/pageParts/PageHeader";
import CoverageMap from "./CoverageMap";
import CardPart from "../../components/pageParts/CardPart";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  background: ${({ theme }) => theme.colors.white};
`;
const WhiteContainer = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 3em 2em;
  }
  display: flex;
  flex-direction: column;
  padding: 0;
  line-height: 1.5em;
`;

const Subtitle = styled.h2`
  border-top: 1px solid ${({ theme }) => theme.colors.opal};
  padding-top: 2em;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 0.6em;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    border: 0;
    padding: 0;
  }
`;
const Text = styled.p`
  font-family: ${({ theme }) => theme.fonts.body};
  color: ${({ theme }) => theme.colors.primary};
`;

const Wrapper = styled.div`
  display: flex;
`;
const Parts = styled.div`
  padding-bottom: 4em;
`;
const Details = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-left: 4em;
    display: flex;
    flex-direction: column;
    width: fit-content;
  }
`;
const NavMenu = styled.div`
  display: none;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 35%;
    flex-direction: column;
    display: flex;
  }
`;
const MenuItem = styled.li`
  list-style: none;
  cursor: pointer;
  padding-bottom: 1em;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.primary};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-top: 1em;
    border-bottom: 1px solid ${({ theme }) => theme.colors.opal};
  }
`;

const Abroad = () => {
  const { t } = useTranslation();
  const scroll = (scrollTo) => {
    document.querySelector(`#${scrollTo}`)?.scrollIntoView({
      behavior: "smooth",
    });
  };
  const cards = ["insurance", "accident", "verification"];
  return (
    <Container>
      <PageHeader
        padding="200px"
        title={t("abroad.title")}
        text={t("abroad.info")}
        background={header}
        imgMobile={headerMobile}
      />
      <WhiteContainer>
        <BodyContentLayout>
          <Wrapper>
            <NavMenu>
              <ul>
                <MenuItem onClick={() => scroll("coverage")}>{t("abroad.coverageTitle")}</MenuItem>
                <MenuItem onClick={() => scroll("campers")}>{t("abroad.campersTitle")}</MenuItem>
                <MenuItem onClick={() => scroll("request")}>{t("abroad.requestTitle")}</MenuItem>
              </ul>
            </NavMenu>
            <Details>
              <Parts id="coverage">
                <Subtitle>{t("abroad.coverageTitle")}</Subtitle>
                <Text>{t("abroad.coverageText")}</Text>
              </Parts>
            </Details>
          </Wrapper>
        </BodyContentLayout>
      </WhiteContainer>

      <CoverageMap />

      <WhiteContainer>
        <BodyContentLayout>
          <Wrapper>
            <NavMenu />
            <Details>
              <Parts id="campers">
                <Subtitle>{t("abroad.campersTitle")}</Subtitle>
                <Text>{t("abroad.campersText")}</Text>
              </Parts>
              <Parts id="request">
                <Subtitle>{t("abroad.requestTitle")}</Subtitle>
                <Text>{t("abroad.requestText")}</Text>
              </Parts>
            </Details>
          </Wrapper>
        </BodyContentLayout>
      </WhiteContainer>
      <CardPart cards={cards} />
      <FaqPart topic={t("header.menu.abroad")} />
    </Container>
  );
};

export default Abroad;
